import axios from 'axios'

export default {
  create ( data, callback, fallback ) {
    axios.post( '/user-types', data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        fallback(error);
      });
  },
  save ( userTypeId, data, callback, fallback ) {
    axios.post( '/user-types/' + userTypeId, data )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
  delete ( userTypeId, callback, fallback ) {
    axios.delete( '/user-types/' + userTypeId )
      .then(resp => {
        callback( typeof(resp.data.result) != 'undefined'? resp.data.result: resp.data );
      })
      .catch(error => {
        if(typeof(fallback) != 'undefined') fallback( error );
      });
  },
}
